import { ButtonContainerProps } from './types';
import * as S from './styles';

const ButtonContainer = (props: ButtonContainerProps): JSX.Element => <S.Container {...props} />;

export default ButtonContainer;
